import React from "react";

export default function GallerySectionHeading({ eyebrow, heading, sub }) {
  return (
    <div className="tp-gallery__header">
      <div>
        <span className="tp-eyebrow">{eyebrow}</span>
        <h2 className="tp-section-heading">{heading}</h2>
        {sub && <p className="tp-section-sub">{sub}</p>}
      </div>
    </div>
  );
}
